module.exports = __webpack_public_path__ + "img/5-1.ed101d44.png";